// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ItemType } from "../inventory/common_pb.js";
import { Patient } from "../patients/common_pb.js";

/**
 * @generated from enum com.neulink.pharmacy.PaymentMode
 */
export enum PaymentMode {
  /**
   * Default value for unknown payment mode
   *
   * @generated from enum value: PAYMENT_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Cash payment
   *
   * @generated from enum value: PAYMENT_MODE_CASH = 1;
   */
  CASH = 1,

  /**
   * Credit card payment
   *
   * @generated from enum value: PAYMENT_MODE_CREDIT_CARD = 2;
   */
  CREDIT_CARD = 2,

  /**
   * Debit card payment
   *
   * @generated from enum value: PAYMENT_MODE_DEBIT_CARD = 3;
   */
  DEBIT_CARD = 3,

  /**
   * Unified Payments Interface (UPI) payment
   *
   * @generated from enum value: PAYMENT_MODE_UPI = 4;
   */
  UPI = 4,

  /**
   * Digital wallet payment
   *
   * @generated from enum value: PAYMENT_MODE_WALLET = 5;
   */
  WALLET = 5,

  /**
   * Bank transfer payment
   *
   * @generated from enum value: PAYMENT_MODE_BANK_TRANSFER = 6;
   */
  BANK_TRANSFER = 6,

  /**
   * Cheque payment
   *
   * @generated from enum value: PAYMENT_MODE_CHEQUE = 7;
   */
  CHEQUE = 7,

  /**
   * Other payment modes not specified
   *
   * @generated from enum value: PAYMENT_MODE_OTHER = 8;
   */
  OTHER = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentMode)
proto3.util.setEnumType(PaymentMode, "com.neulink.pharmacy.PaymentMode", [
  { no: 0, name: "PAYMENT_MODE_UNKNOWN" },
  { no: 1, name: "PAYMENT_MODE_CASH" },
  { no: 2, name: "PAYMENT_MODE_CREDIT_CARD" },
  { no: 3, name: "PAYMENT_MODE_DEBIT_CARD" },
  { no: 4, name: "PAYMENT_MODE_UPI" },
  { no: 5, name: "PAYMENT_MODE_WALLET" },
  { no: 6, name: "PAYMENT_MODE_BANK_TRANSFER" },
  { no: 7, name: "PAYMENT_MODE_CHEQUE" },
  { no: 8, name: "PAYMENT_MODE_OTHER" },
]);

/**
 * @generated from enum com.neulink.pharmacy.SaleStatus
 */
export enum SaleStatus {
  /**
   * Default value, not specified
   *
   * @generated from enum value: SALE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sale is pending payment
   *
   * @generated from enum value: SALE_STATUS_PENDING_PAYMENT = 1;
   */
  PENDING_PAYMENT = 1,

  /**
   * Sale has been completed
   *
   * @generated from enum value: SALE_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Sale is on hold
   *
   * @generated from enum value: SALE_STATUS_ON_HOLD = 3;
   */
  ON_HOLD = 3,

  /**
   * Sale has been voided
   *
   * @generated from enum value: SALE_STATUS_VOIDED = 4;
   */
  VOIDED = 4,

  /**
   * Sale has been partially refunded
   *
   * @generated from enum value: SALE_STATUS_PARTIALLY_REFUNDED = 5;
   */
  PARTIALLY_REFUNDED = 5,

  /**
   * Sale has been fully refunded
   *
   * @generated from enum value: SALE_STATUS_FULLY_REFUNDED = 6;
   */
  FULLY_REFUNDED = 6,

  /**
   * Sale has been exchanged
   *
   * @generated from enum value: SALE_STATUS_EXCHANGED = 7;
   */
  EXCHANGED = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(SaleStatus)
proto3.util.setEnumType(SaleStatus, "com.neulink.pharmacy.SaleStatus", [
  { no: 0, name: "SALE_STATUS_UNSPECIFIED" },
  { no: 1, name: "SALE_STATUS_PENDING_PAYMENT" },
  { no: 2, name: "SALE_STATUS_COMPLETED" },
  { no: 3, name: "SALE_STATUS_ON_HOLD" },
  { no: 4, name: "SALE_STATUS_VOIDED" },
  { no: 5, name: "SALE_STATUS_PARTIALLY_REFUNDED" },
  { no: 6, name: "SALE_STATUS_FULLY_REFUNDED" },
  { no: 7, name: "SALE_STATUS_EXCHANGED" },
]);

/**
 * @generated from enum com.neulink.pharmacy.RefundMode
 */
export enum RefundMode {
  /**
   * Default value for unknown refund mode
   *
   * @generated from enum value: REFUND_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Cash refund
   *
   * @generated from enum value: REFUND_MODE_CASH = 1;
   */
  CASH = 1,

  /**
   * Card reversal refund
   *
   * @generated from enum value: REFUND_MODE_CARD_REVERSAL = 2;
   */
  CARD_REVERSAL = 2,

  /**
   * Store credit refund
   *
   * @generated from enum value: REFUND_MODE_STORE_CREDIT = 3;
   */
  STORE_CREDIT = 3,

  /**
   * Bank transfer refund
   *
   * @generated from enum value: REFUND_MODE_BANK_TRANSFER = 4;
   */
  BANK_TRANSFER = 4,

  /**
   * Adjustment note refund
   *
   * @generated from enum value: REFUND_MODE_ADJUSTMENT_NOTE = 5;
   */
  ADJUSTMENT_NOTE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(RefundMode)
proto3.util.setEnumType(RefundMode, "com.neulink.pharmacy.RefundMode", [
  { no: 0, name: "REFUND_MODE_UNKNOWN" },
  { no: 1, name: "REFUND_MODE_CASH" },
  { no: 2, name: "REFUND_MODE_CARD_REVERSAL" },
  { no: 3, name: "REFUND_MODE_STORE_CREDIT" },
  { no: 4, name: "REFUND_MODE_BANK_TRANSFER" },
  { no: 5, name: "REFUND_MODE_ADJUSTMENT_NOTE" },
]);

/**
 * @generated from message com.neulink.pharmacy.SaleItem
 */
export class SaleItem extends Message<SaleItem> {
  /**
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 1;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId = "";

  /**
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * @generated from field: float unit_selling_price = 4;
   */
  unitSellingPrice = 0;

  /**
   * Discount applied to the item
   *
   * @generated from field: float item_discount = 5;
   */
  itemDiscount = 0;

  /**
   * Amount subject to tax
   *
   * @generated from field: float taxable_amount = 6;
   */
  taxableAmount = 0;

  /**
   * List of taxes applied to the item
   *
   * @generated from field: repeated com.neulink.pharmacy.TaxInfo taxes = 7;
   */
  taxes: TaxInfo[] = [];

  /**
   * Total tax amount for the item
   *
   * @generated from field: float total_tax_amount = 8;
   */
  totalTaxAmount = 0;

  /**
   * Total amount for the item after tax and discount
   *
   * @generated from field: float total_amount = 9;
   */
  totalAmount = 0;

  /**
   * Additional information about the item
   *
   * @generated from field: map<string, string> metadata = 10;
   */
  metadata: { [key: string]: string } = {};

  constructor(data?: PartialMessage<SaleItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SaleItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 2, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "unit_selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "item_discount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "taxable_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "taxes", kind: "message", T: TaxInfo, repeated: true },
    { no: 8, name: "total_tax_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaleItem {
    return new SaleItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaleItem {
    return new SaleItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaleItem {
    return new SaleItem().fromJsonString(jsonString, options);
  }

  static equals(a: SaleItem | PlainMessage<SaleItem> | undefined, b: SaleItem | PlainMessage<SaleItem> | undefined): boolean {
    return proto3.util.equals(SaleItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SaleLineItem
 */
export class SaleLineItem extends Message<SaleLineItem> {
  /**
   * Unique identifier for the item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Quantity of the item sold
   *
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * Price per unit of the item
   *
   * @generated from field: float unit_price = 4;
   */
  unitPrice = 0;

  /**
   * Optional notes for the item
   *
   * @generated from field: string notes = 5;
   */
  notes = "";

  /**
   * Name of the item
   *
   * @generated from field: string trade_name = 6;
   */
  tradeName = "";

  /**
   * Unit of measurement for the item
   *
   * @generated from field: int32 unit = 7;
   */
  unit = 0;

  /**
   * Type of unit (e.g., "mg", "ml", "pcs")
   *
   * @generated from field: string unit_type = 8;
   */
  unitType = "";

  /**
   * List of taxes applied to the item
   *
   * @generated from field: repeated com.neulink.pharmacy.TaxInfo taxes = 9;
   */
  taxes: TaxInfo[] = [];

  /**
   * Total tax amount for the item
   *
   * @generated from field: float taxable_amount = 10;
   */
  taxableAmount = 0;

  /**
   * Total amount for the item after tax and discount
   *
   * @generated from field: float total_amount = 11;
   */
  totalAmount = 0;

  /**
   * Additional information about the item
   *
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string } = {};

  /**
   * Batch ID of the item, if applicable
   *
   * @generated from field: string batch_id = 13;
   */
  batchId = "";

  /**
   * Expiry date of the item, if applicable
   *
   * @generated from field: google.protobuf.Timestamp expiry_date = 14;
   */
  expiryDate?: Timestamp;

  /**
   * Batch number of the item, if applicable
   *
   * @generated from field: string batch_number = 15;
   */
  batchNumber = "";

  /**
   * Discount applied to the item
   *
   * @generated from field: float item_discount = 16;
   */
  itemDiscount = 0;

  /**
   * Total tax amount for the item
   *
   * @generated from field: float total_tax_amount = 17;
   */
  totalTaxAmount = 0;

  /**
   * Unique identifier for the sale item
   *
   * @generated from field: string sale_item_id = 18;
   */
  saleItemId = "";

  /**
   * Flag indicating if the item has been refunded
   *
   * @generated from field: bool is_refunded = 19;
   */
  isRefunded = false;

  /**
   * Reason for refunding the item, if applicable
   *
   * @generated from field: string refund_reason = 20;
   */
  refundReason = "";

  /**
   * Unique identifier for the refund, if applicable
   *
   * @generated from field: string refund_id = 21;
   */
  refundId = "";

  /**
   * Mode of refund (e.g., cash, card, etc.)
   *
   * @generated from field: com.neulink.pharmacy.RefundMode refund_mode = 22;
   */
  refundMode = RefundMode.UNKNOWN;

  /**
   * Timestamp when the item was refunded
   *
   * @generated from field: google.protobuf.Timestamp refunded_at = 23;
   */
  refundedAt?: Timestamp;

  /**
   * User who processed the refund, if applicable
   *
   * @generated from field: com.neulink.pharmacy.UserInfo refunded_by = 24;
   */
  refundedBy?: UserInfo;

  constructor(data?: PartialMessage<SaleLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SaleLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "unit_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "taxes", kind: "message", T: TaxInfo, repeated: true },
    { no: 10, name: "taxable_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 12, name: "metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 13, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 15, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "item_discount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 17, name: "total_tax_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 18, name: "sale_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "is_refunded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "refund_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "refund_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "refund_mode", kind: "enum", T: proto3.getEnumType(RefundMode) },
    { no: 23, name: "refunded_at", kind: "message", T: Timestamp },
    { no: 24, name: "refunded_by", kind: "message", T: UserInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaleLineItem {
    return new SaleLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaleLineItem {
    return new SaleLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaleLineItem {
    return new SaleLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: SaleLineItem | PlainMessage<SaleLineItem> | undefined, b: SaleLineItem | PlainMessage<SaleLineItem> | undefined): boolean {
    return proto3.util.equals(SaleLineItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TaxInfo
 */
export class TaxInfo extends Message<TaxInfo> {
  /**
   * Code of the tax component
   *
   * @generated from field: string component_code = 1;
   */
  componentCode = "";

  /**
   * Description of the tax component
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * Tax rate as a percentage
   *
   * @generated from field: float rate = 3;
   */
  rate = 0;

  /**
   * Amount of tax applied
   *
   * @generated from field: float amount = 4;
   */
  amount = 0;

  constructor(data?: PartialMessage<TaxInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TaxInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "component_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TaxInfo {
    return new TaxInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TaxInfo {
    return new TaxInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TaxInfo {
    return new TaxInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TaxInfo | PlainMessage<TaxInfo> | undefined, b: TaxInfo | PlainMessage<TaxInfo> | undefined): boolean {
    return proto3.util.equals(TaxInfo, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PaymentInfo
 */
export class PaymentInfo extends Message<PaymentInfo> {
  /**
   * Mode of payment (e.g., cash, card, etc.)
   *
   * @generated from field: com.neulink.pharmacy.PaymentMode payment_mode = 1;
   */
  paymentMode = PaymentMode.UNKNOWN;

  /**
   * Amount paid in this payment mode
   *
   * @generated from field: float amount = 2;
   */
  amount = 0;

  /**
   * Transaction ID for the payment, if applicable
   *
   * @generated from field: string transaction_id = 3;
   */
  transactionId = "";

  /**
   * Type of card used for payment (e.g., Visa, MasterCard)
   *
   * @generated from field: string card_type = 4;
   */
  cardType = "";

  /**
   * Masked card number (e.g., last four digits)
   *
   * @generated from field: string card_last_four_digits = 5;
   */
  cardLastFourDigits = "";

  constructor(data?: PartialMessage<PaymentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PaymentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_mode", kind: "enum", T: proto3.getEnumType(PaymentMode) },
    { no: 2, name: "amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "card_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "card_last_four_digits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentInfo {
    return new PaymentInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentInfo {
    return new PaymentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentInfo {
    return new PaymentInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentInfo | PlainMessage<PaymentInfo> | undefined, b: PaymentInfo | PlainMessage<PaymentInfo> | undefined): boolean {
    return proto3.util.equals(PaymentInfo, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InsuranceInfo
 */
export class InsuranceInfo extends Message<InsuranceInfo> {
  /**
   * ID of the insurance provider
   *
   * @generated from field: string insurance_provider_id = 1;
   */
  insuranceProviderId = "";

  /**
   * Insurance policy number
   *
   * @generated from field: string policy_number = 2;
   */
  policyNumber = "";

  /**
   * Approval code for the insurance claim
   *
   * @generated from field: string approval_code = 3;
   */
  approvalCode = "";

  /**
   * Co-pay amount for the insurance
   *
   * @generated from field: float co_pay_amount = 4;
   */
  coPayAmount = 0;

  /**
   * Total amount covered by the insurance
   *
   * @generated from field: float total_covered_amount = 5;
   */
  totalCoveredAmount = 0;

  constructor(data?: PartialMessage<InsuranceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InsuranceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "insurance_provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "policy_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "co_pay_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_covered_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsuranceInfo {
    return new InsuranceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsuranceInfo {
    return new InsuranceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsuranceInfo {
    return new InsuranceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: InsuranceInfo | PlainMessage<InsuranceInfo> | undefined, b: InsuranceInfo | PlainMessage<InsuranceInfo> | undefined): boolean {
    return proto3.util.equals(InsuranceInfo, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UserInfo
 */
export class UserInfo extends Message<UserInfo> {
  /**
   * ID of the user
   *
   * @generated from field: int32 user_id = 1;
   */
  userId = 0;

  /**
   * Username of the user
   *
   * @generated from field: string username = 2;
   */
  username = "";

  /**
   * Full name of the user
   *
   * @generated from field: string full_name = 3;
   */
  fullName = "";

  constructor(data?: PartialMessage<UserInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UserInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInfo {
    return new UserInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInfo {
    return new UserInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInfo {
    return new UserInfo().fromJsonString(jsonString, options);
  }

  static equals(a: UserInfo | PlainMessage<UserInfo> | undefined, b: UserInfo | PlainMessage<UserInfo> | undefined): boolean {
    return proto3.util.equals(UserInfo, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SaleValues
 */
export class SaleValues extends Message<SaleValues> {
  /**
   * Subtotal amount of the sale before taxes and discounts
   *
   * @generated from field: float sub_total_amount = 1;
   */
  subTotalAmount = 0;

  /**
   * Total discount amount applied to all items
   *
   * @generated from field: float total_item_discount_amount = 2;
   */
  totalItemDiscountAmount = 0;

  /**
   * Total tax amount applied to the sale
   *
   * @generated from field: float total_tax_amount = 3;
   */
  totalTaxAmount = 0;

  /**
   * Total amount covered by insurance
   *
   * @generated from field: float total_insurance_coverage = 4;
   */
  totalInsuranceCoverage = 0;

  /**
   * Total amount paid by the customer
   *
   * @generated from field: float total_paid_by_customer = 5;
   */
  totalPaidByCustomer = 0;

  /**
   * Status of the sale (e.g., COMPLETED, PENDING)
   *
   * @generated from field: com.neulink.pharmacy.SaleStatus status = 6;
   */
  status = SaleStatus.UNSPECIFIED;

  /**
   * Flag indicating if the sale is voided
   *
   * @generated from field: bool is_voided = 7;
   */
  isVoided = false;

  /**
   * User who voided the sale, if applicable
   *
   * @generated from field: com.neulink.pharmacy.UserInfo voided_by = 8;
   */
  voidedBy?: UserInfo;

  /**
   * Timestamp when the sale was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * Timestamp when the sale was last voided
   *
   * @generated from field: google.protobuf.Timestamp voided_at = 10;
   */
  voidedAt?: Timestamp;

  /**
   * Reason for voiding the sale, if applicable
   *
   * @generated from field: string void_reason = 11;
   */
  voidReason = "";

  /**
   * Net amount before tax calculations
   *
   * @generated from field: float net_amount_before_tax = 12;
   */
  netAmountBeforeTax = 0;

  /**
   * Grand total amount of the sale after all calculations
   *
   * @generated from field: float grand_total_amount = 13;
   */
  grandTotalAmount = 0;

  /**
   * Total amount collected from the customer
   *
   * @generated from field: float total_amount_collected = 14;
   */
  totalAmountCollected = 0;

  /**
   * Amount due from/to the customer
   *
   * @generated from field: float due_amount = 15;
   */
  dueAmount = 0;

  /**
   * Total number of items in the sale
   *
   * @generated from field: float item_count = 16;
   */
  itemCount = 0;

  constructor(data?: PartialMessage<SaleValues>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SaleValues";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sub_total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "total_item_discount_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "total_tax_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_insurance_coverage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_paid_by_customer", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(SaleStatus) },
    { no: 7, name: "is_voided", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "voided_by", kind: "message", T: UserInfo },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "voided_at", kind: "message", T: Timestamp },
    { no: 11, name: "void_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "net_amount_before_tax", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "grand_total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "total_amount_collected", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "due_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "item_count", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaleValues {
    return new SaleValues().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaleValues {
    return new SaleValues().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaleValues {
    return new SaleValues().fromJsonString(jsonString, options);
  }

  static equals(a: SaleValues | PlainMessage<SaleValues> | undefined, b: SaleValues | PlainMessage<SaleValues> | undefined): boolean {
    return proto3.util.equals(SaleValues, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.Sale
 */
export class Sale extends Message<Sale> {
  /**
   * Unique identifier for the sale
   *
   * @generated from field: string sale_id = 1;
   */
  saleId = "";

  /**
   * Receipt number for the sale
   *
   * @generated from field: string receipt_number = 2;
   */
  receiptNumber = "";

  /**
   * Additional values related to the sale
   *
   * @generated from field: com.neulink.pharmacy.SaleValues sale_values = 3;
   */
  saleValues?: SaleValues;

  /**
   * Optional: Patient details if patient_id is provided
   *
   * @generated from field: com.neulink.pharmacy.Patient patient = 4;
   */
  patient?: Patient;

  /**
   * User who requested the list of sales
   *
   * @generated from field: com.neulink.pharmacy.UserInfo created_by = 5;
   */
  createdBy?: UserInfo;

  /**
   * Flag indicating if the patient is valid
   *
   * @generated from field: bool is_valid_patient = 6;
   */
  isValidPatient = false;

  constructor(data?: PartialMessage<Sale>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Sale";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "receipt_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sale_values", kind: "message", T: SaleValues },
    { no: 4, name: "patient", kind: "message", T: Patient },
    { no: 5, name: "created_by", kind: "message", T: UserInfo },
    { no: 6, name: "is_valid_patient", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Sale {
    return new Sale().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Sale {
    return new Sale().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Sale {
    return new Sale().fromJsonString(jsonString, options);
  }

  static equals(a: Sale | PlainMessage<Sale> | undefined, b: Sale | PlainMessage<Sale> | undefined): boolean {
    return proto3.util.equals(Sale, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.RefundItem
 */
export class RefundItem extends Message<RefundItem> {
  /**
   * Unique identifier for the item being refunded
   *
   * @generated from field: string item_id = 1;
   */
  itemId = "";

  /**
   * Quantity of the item to be refunded
   *
   * @generated from field: float quantity = 2;
   */
  quantity = 0;

  /**
   * Type of the item being refunded
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Mode of refund (e.g., cash, card, etc.)
   *
   * @generated from field: com.neulink.pharmacy.RefundMode refund_mode = 4;
   */
  refundMode = RefundMode.UNKNOWN;

  constructor(data?: PartialMessage<RefundItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RefundItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 4, name: "refund_mode", kind: "enum", T: proto3.getEnumType(RefundMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefundItem {
    return new RefundItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefundItem {
    return new RefundItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefundItem {
    return new RefundItem().fromJsonString(jsonString, options);
  }

  static equals(a: RefundItem | PlainMessage<RefundItem> | undefined, b: RefundItem | PlainMessage<RefundItem> | undefined): boolean {
    return proto3.util.equals(RefundItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.SalesUsers
 */
export class SalesUsers extends Message<SalesUsers> {
  /**
   * ID of the user associated with the sale
   *
   * @generated from field: int32 user_id = 1;
   */
  userId = 0;

  /**
   * Username of the user
   *
   * @generated from field: string username = 2;
   */
  username = "";

  /**
   * Full name of the user
   *
   * @generated from field: string full_name = 3;
   */
  fullName = "";

  constructor(data?: PartialMessage<SalesUsers>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.SalesUsers";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SalesUsers {
    return new SalesUsers().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SalesUsers {
    return new SalesUsers().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SalesUsers {
    return new SalesUsers().fromJsonString(jsonString, options);
  }

  static equals(a: SalesUsers | PlainMessage<SalesUsers> | undefined, b: SalesUsers | PlainMessage<SalesUsers> | undefined): boolean {
    return proto3.util.equals(SalesUsers, a, b);
  }
}

